import Blue from "~/core";

function setupMaxValidation(inputEl) {
  if (!inputEl) return;
  
  inputEl.addEventListener('invalid', function() {
    const max = inputEl.getAttribute('max');
    if (inputEl.validity.rangeOverflow && max) {
      inputEl.setCustomValidity(`Only ${max} left in stock.`);
    }
  });

  inputEl.addEventListener('input', function() {
    inputEl.setCustomValidity('');
  });
}

function isWithinBounds(inputEl, newVal) {
  const inputMin = inputEl.getAttribute('min');
  const minVal = inputMin !== null && inputMin !== "" ? parseInt(inputMin) : 1;
  if (newVal < minVal) return false;

  const inputMax = inputEl.getAttribute('max');
  if (inputMax !== null && inputMax !== "" && newVal > parseInt(inputMax)) {
    return false;
  }

  return true;
}

function setupCustomNumberInput(blueInstance, form, onUpdate) {
  const inputEl = form.querySelector('input[type="number"]');
  const minus = form.querySelector('.minus__btn');
  const plus = form.querySelector('.plus__btn');

  setupMaxValidation(inputEl);

  function updateInput(newVal, showMaxValidation = false) {
    if (!isWithinBounds(inputEl, newVal)) {
      if (showMaxValidation) {
        const inputMax = inputEl.getAttribute('max');
        if (inputMax !== null && inputMax !== "" && newVal > parseInt(inputMax)) {
          inputEl.setCustomValidity(`Only ${inputMax} left in stock.`);
          inputEl.reportValidity();
        }
      }
      return;
    }
    inputEl.setCustomValidity('');
    inputEl.value = newVal;
    if (onUpdate) onUpdate();
  }

  const getCurrentValue = () => parseInt(inputEl.value) || 1;
  blueInstance.$addEvents(minus, 'click', () => updateInput(getCurrentValue() - 1));
  blueInstance.$addEvents(plus, 'click', () => updateInput(getCurrentValue() + 1, true));
}

new Blue({
	name: 'Form Validate',
	selector: ".form--validate",
	setup(form) {
		this.$validate(form);
	}
});

new Blue({
  name: 'Focus First Invalid Form Control',
  selector: "form",
  setup(form){
    const ariaDescribedByAttributes = Array.from(form.querySelectorAll("[aria-describedby]:not([aria-describedby=''])"));
    
    // Get all the elements containing error messages.
    const formErrorMessageContainers = ariaDescribedByAttributes.map(x => {
        return form.querySelector(`#${x.getAttribute("aria-describedby")}`);
    }).filter(x => x !== null && x !== '');
    
    formErrorMessageContainers.forEach(error => {
        if (error.innerText === null || error.innerText === "") {
            return;
        }
        
        // Get the form element that the error message is associated with.
        let linkedElementId = error.getAttribute("data-valmsg-for");
        let erroredElement = form.querySelector(`#${linkedElementId}`);
                            
        if (erroredElement){
            // Mark the element as errored to Assistive Technology.
            erroredElement.setAttribute("aria-invalid", "true");                            
        }
    });
    
    // Focus the first invalid element in the form.
    let firstErroredElement = form.querySelector("[aria-invalid='true']");
    
    if (firstErroredElement){
        // Focus the element after a short delay to allow 
        // a Screen Reader to possibly finish some announcements. 
        setTimeout(() => firstErroredElement.focus(), 500);   
    }
  }
});

new Blue({
	name: 'Custom Number Input Checkout',
	selector: ".order-cart .form--custom-numinput",
	setup(form) {
    window.onbeforeunload = null;
    const updateBtn = form.parentElement.querySelector('.btn--update');
    setupCustomNumberInput(this, form, () => updateBtn.click());
	}
});

new Blue({
	name: 'Custom Number Input Product Page',
	selector: ".feature-block__form--cart .form--custom-numinput",
	setup(form) {
    setupCustomNumberInput(this, form);
    const parentForm = form.closest('form');
    if (parentForm) {
      const inputEl = form.querySelector('input[type="number"]');
      const submitBtn = parentForm.querySelector('input[type="submit"]');
      
      // Clear custom validity before form validation runs
      if (submitBtn) {
        submitBtn.addEventListener('pointerdown', () => inputEl.setCustomValidity(''));
      }

      inputEl.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') inputEl.setCustomValidity('');
      });
    }
	}
});

new Blue({
	name: 'Account Input Phone Mask',
	selector: ".account__input[type='tel'], .checkout__section-input[type='tel']",
	setup(phoneInput) {
		phoneInput.addEventListener("input", (e) => {
      const value = phoneInput.value.replace(/\D+/g, "");
      const numberLength = 12;
    
      let result = "";
    
      //
      for (let i = 0; i < value.length && i < numberLength; i++) {
        switch (i) {
          case 0:
            result += "";
            break;
          case 3:
            result += "-";
            break;
          case 6:
            result += "-";
            break;
          default:
            break;
        }
        result += value[i];
      }
      //
      phoneInput.value = result;
    });
	}
});



new Blue({
	name: 'Shipping Options Spinner',
	selector: "#shippingOptions input[type='submit']",
	setup(btn) {
    const spinner = btn.parentElement.querySelector('.checkout-spinner');
		btn.addEventListener("click", (e) => {
      if (btn)
        btn.classList.add('submitting');
      if (spinner)
        spinner.classList.add('showing');
    });
	}
});

new Blue({
  name: "Address Selector",
  selector: ".account__address",
  setup(addressElement) {
    const radioButton = addressElement.querySelector('input[type="radio"]');

    if (radioButton) {
      this.$addEvents(addressElement, "click", function (event) {
        if (event.target.closest("a, button")) {
          return;
        }

        radioButton.checked = true;

        radioButton.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }
  },
});